export const CheckChurnZeroUser = ({ client_name, url_id }) => {
  if (url_id !== null && url_id !== 96) {
    const email = process.env.REACT_APP_PUBLIC_CONTACT;
    window.ChurnZero.push(['setContact', client_name, email]);
  }
};
